import request from './request'

// 获取店铺列表
export function shopGetList(params) {
  return request({
    url: '/shop/list',
    method: 'get',
    params
  })
}

// 店铺创建
export function shopCreate(data) {
  return request({
    url: '/shop/create',
    method: 'post',
    data
  })
}

// 店铺编辑
export function shopUpdate(id, data) {
  return request({
    url: '/shop/update/' + id,
    method: 'put',
    data
  })
}

// 店铺删除
export function shopDelete(id, data) {
  return request({
    url: '/shop/delete/' + id,
    method: 'delete',
    data
  })
}

// 店铺状态
export function shopStatus(data) {
  return request({
    url: '/shop/updateStatus',
    method: 'post',
    data
  })
}